// 9fbef606107a605d69c0edbcd8029e5d
import { fromJS } from 'immutable';
import {
  LOAD_RECOMMENDATIONS_DATA,
  UPDATE_RECOMMENDATIONS_DATA,
  OPEN_RECOMMENDATION_ORDER_MODAL,
  CLOSE_RECOMMENDATION_ORDER_MODAL,
  SET_RECOMMENDATION_LOADING_STATE,
  LOAD_RECOMMENDATIONS_ALL_DATA,
  LOAD_RECOMMENDATIONS_GIRL_DATA,
  LOAD_RECOMMENDATIONS_BOY_DATA,
  LOAD_RECOMMENDATIONS_BABY_DATA,
  LOAD_RECOMMENDATIONS_TODDLER_BOY_DATA,
  LOAD_RECOMMENDATIONS_TODDLER_GIRL_DATA,
  LOAD_RECOMMENDATIONS_LOADER,
  CLEAR_RECOMMENDATIONS_DATA,
} from './Recommendations.constants';

const initialState = fromJS({});

const getDefaultState = (state) => {
  // TODO: currently when initial state is hydrated on browser, List is getting converted to an JS Array
  if (state instanceof Object) {
    return fromJS(state);
  }
  return state;
};

const RecommendationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_RECOMMENDATIONS_DATA:
      return state.set(action.payload.reduxKey, action.payload.result);
    case LOAD_RECOMMENDATIONS_LOADER:
      return state.set(action.payload.reduxKey, action.payload.result);
    case LOAD_RECOMMENDATIONS_ALL_DATA:
      return state.set(action.payload.reduxKey, action.payload.categoryResult);
    case LOAD_RECOMMENDATIONS_GIRL_DATA:
      return state.set(action.payload.reduxKey, action.payload.categoryResult);
    case LOAD_RECOMMENDATIONS_BOY_DATA:
      return state.set(action.payload.reduxKey, action.payload.categoryResult);
    case LOAD_RECOMMENDATIONS_BABY_DATA:
      return state.set(action.payload.reduxKey, action.payload.categoryResult);
    case LOAD_RECOMMENDATIONS_TODDLER_GIRL_DATA:
      return state.set(action.payload.reduxKey, action.payload.categoryResult);
    case LOAD_RECOMMENDATIONS_TODDLER_BOY_DATA:
      return state.set(action.payload.reduxKey, action.payload.categoryResult);
    case UPDATE_RECOMMENDATIONS_DATA:
      return state.set('isUpdating', action.payload.isUpdating);
    case OPEN_RECOMMENDATION_ORDER_MODAL:
      return state.set('orderRecommendationModal', {
        isOpen: action.payload.isOpen,
        partNumbers: action.payload.partNumbers,
      });
    case CLOSE_RECOMMENDATION_ORDER_MODAL:
      return state.set('orderRecommendationModal', {
        isOpen: action.payload.isOpen,
      });
    case SET_RECOMMENDATION_LOADING_STATE:
      return state.set('isLoading', action.payload.isLoading);
    case CLEAR_RECOMMENDATIONS_DATA:
      return state.remove(action.payload.reduxKey);
    default:
      return getDefaultState(state);
  }
};

export default RecommendationsReducer;
